import { useCallback } from 'react'

import { RegionStore } from 'common/region/region'
import { GlobalFilterState } from 'modules/Monitoring/GlobalFilters/GlobalFilters'
import { useSearchParams } from 'modules/Monitoring/router/useSearchParams'
import { UrlStateStorageKeys } from 'modules/Monitoring/url-state-storage/consts'
import { useHashedSearchParams } from 'modules/Monitoring/url-state-storage/useHashedSearchParams'
import { encodeState } from 'modules/Monitoring/url-state-storage/utils/encodeState'

import { Route } from '../consts/routes'
import { UrlSearchParam } from '../consts/url'

import { useChannel } from './useChannel'

export const useCreateAgentsRoute = (agentIds: string[]) => {
  const [searchParams] = useSearchParams()
  const { channel, regionedChannel } = useChannel()

  const { state } = useHashedSearchParams<GlobalFilterState>({
    hashParamKey: UrlStateStorageKeys.GlobalFilters,
    contextKey: regionedChannel,
  })

  const currentRegion = RegionStore.region

  return useCallback(() => {
    const encodedState = encodeState({ ...state, agents: agentIds })
    const newSearchParams = new URLSearchParams(searchParams)

    newSearchParams.set(UrlSearchParam.Channel, channel)
    newSearchParams.set(UrlSearchParam.Region, currentRegion)

    if (encodedState) {
      newSearchParams.set(UrlStateStorageKeys.GlobalFilters, encodedState)
    }

    return `${Route.Agent}?${newSearchParams.toString()}`
  }, [agentIds, state, searchParams, channel, currentRegion])
}
